import React, { useState, useEffect } from 'react'
import { styled } from '../../stitches.config'
import { SwitchTransition, CSSTransition } from 'react-transition-group'

const SwitchText = ({ firstText = '', secondText = '', timeout = 2000, render }) => {
    const [switchText, setSwitchText] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setSwitchText(true), timeout)
        return () => clearTimeout(timer)
    }, []);

    return (<Wrap>
        <SwitchTransition>
            <CSSTransition
                key={switchText ? "thankyou" : "percentage"}
                timeout={500}
                addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
                classNames='fade'>
                {render(switchText ? secondText : firstText)}
            </CSSTransition>
        </SwitchTransition>
    </Wrap>)
}

const Wrap = styled("div", {
    ".fade-enter": {
        opacity: 0
    },
    ".fade-exit": {
        opacity: 1
    },
    ".fade-enter-active": {
        opacity: 1
    },
    ".fade-exit-active": {
        opacity: 0
    },
    ".fade-enter-active, .fade-exit-active": {
        transition: "opacity 500ms"
    }
});

export default SwitchText